<template>
	<main id="container" class="page-container">
		<div class="page-header">
			<div class="container">
				<div class="display-flex is-between">
					<page-header title="이벤트" />
				</div>
			</div>
		</div>
		<div class="page-content event-check event-ranking">
			<div class="container">
				<div class="page-sub-header">
					<h3 class="page-sub-title"><span class="prima">동행축제 이벤트에 참여하고</span> 푸짐한 선물 받으세요.</h3>
				</div>
			</div>
			<div class="page-tab-container">
				<div class="container tab-buttons">
					<router-link to="eatingOut" class="tab-button">외식 활성화</router-link>
					<router-link to="check" class="tab-button">출석체크</router-link>
					<router-link to="ranking" class="tab-button is-active">랭킹게임</router-link>
					<router-link to="dibs" class="tab-button">찜하기</router-link>
					<router-link to="sns" class="tab-button">구매후기</router-link>
					<router-link to="delivery" class="tab-button">공공배달앱 이용후기</router-link>
					<router-link to="challenge" class="tab-button">동행 숨결 챌린지</router-link>
				</div>
			</div>
			<div class="container">
				<div class="event-check-container">
					<div class="event-check-header">
						<div class="event-check-header-img">
							<div class="banner-img">
								<img src="@/assets/img/event/event2412_4_2.jpg" alt="EVENT 02 랭킹게임 이벤트" />
							</div>
						</div>
						<div class="event-check-header-info">
							<ul class="event-check-header-info-list">
								<li v-for="(item, idx) in infoList" :key="idx">
									<span class="infolist-title">{{ item.title }}</span>
									<span class="infolist-text">{{ item.detail }}</span>
								</li>
							</ul>
						</div>
					</div>
					<div class="event-check-guide">
						<span class="event-check-guide-title">참여방법</span>
						<div class="event-check-guide-desc no-border">
							<ul class="event-check-guide-desclist">
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e41.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 1</span>
										<span class="desclist-text">랭킹게임 참여 시, 간편가입을 통한 로그인은 필수입니다</span>
									</div>
								</li>
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e42.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 2</span>
										<span class="desclist-text">동행 장바구니를 좌우로 옮기면서 폭탄을 피해 떨어지는 동행 아이템을 획득합니다. </span>
									</div>
								</li>
								<li class="event-check-guide-desclist-li">
									<div class="event-check-guide-desclist-img hidden-mobile">
										<img src="@/assets/img/event/icon_e43.png" alt="" />
									</div>
									<div class="event-check-guide-desclist-text">
										<span class="desclist-title">STEP 3</span>
										<span class="desclist-text">게임 진행 기간 중, 랭킹 상관없이 깜짝 경품 이벤트를 진행합니다. </span>
										<div class="desclist-tag">
											<span class="tag-title">깜짝이벤트</span>
											<div class="tag-item">
												<span class="desc">12월 10일(화) 10명, 12월 20일(금) 20명에게 랭킹 상관없이 치킨 쿠폰 랜덤 지급 </span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="event-check-products">
						<span class="event-check-products-title">경품소개</span>
						<ul class="event-check-products-list">
							<li class="event-check-products-list-li" v-for="(item, idx) in prdList" :key="idx">
								<div class="event-check-products-item">
									<div class="event-check-products-item-img">
										<img :src="require(`@/assets/img/main/${item.img}`)" :alt="item.title" />
									</div>
									<div class="event-check-products-item-title">
										<span class="item-title-wrap">
											<span class="item-title">{{ item.title }}</span>
											<span class="item-title boldtxt">{{ item.person }}</span>
										</span>
									</div>
								</div>
							</li>
						</ul>
						<span class="event-check-products-title color-red">깜짝 이벤트 경품</span>
						<ul class="event-check-products-list">
							<li class="event-check-products-list-li" v-for="(item, idx) in prdList1" :key="idx">
								<div class="event-check-products-item">
									<div class="event-check-products-item-img">
										<img :src="require(`@/assets/img/main/${item.img}`)" :alt="item.title" />
									</div>
									<div class="event-check-products-item-title">
										<span class="item-title-wrap">
											<span class="item-title">{{ item.title }}</span>
											<span class="item-title color-red">{{ item.sub }}</span>
											<span class="item-title boldtxt">{{ item.person }}</span>
										</span>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="event-check-button-box">
				<div class="container flex-column">
					<span class="event-check-prect-title">경품발송</span>
					<ul class="event-check-prect-list">
						<li class="event-check-prect-list-li" v-for="(item, idx) in deliveryList" :key="idx">
							<span class="prect-list-text" v-html="item"></span>
						</li>
					</ul>
					<button type="button" v-if="isShowBtn" class="event-check-button" @click="clickEvent">랭킹게임 이벤트 참여</button>
				</div>
			</div>
			<div class="event-check-prect">
				<div class="container">
					<span class="event-check-prect-title">유의사항</span>
					<ul class="event-check-prect-list">
						<li class="event-check-prect-list-li" v-for="(item, idx) in prectList" :key="idx">
							<span class="prect-list-text">{{ item }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import PageHeader from '@/components/content/PageHeader';
export default {
	name: 'EventRanking',
	components: { PageHeader },
	data: () => ({
		visibleModal: false,
		infoList: [
			{
				title: '참여기간',
				detail: '2024년 12월 1일(일) ~ 2024년 12월 28일(토)',
			},
			{
				title: '결과발표',
				detail: '2025년 1월 중',
			},
			{
				title: '경품발송',
				detail: '2025년 2월 중',
			},
			{
				title: '진행방식',
				detail: '홈페이지 접속 시 자동 팝업 생성, 팝업창 내에서 게임 참여 가능',
			},
		],
		prdList: [
			{
				img: 'item_image_6.jpg',
				title: '동행제품 선물박스 20만원 상당',
				person: '(1명)',
			},
			{
				img: 'item_image_6.jpg',
				title: '동행제품 선물박스 10만원 상당',
				person: '(1명)',
			},
			{
				img: 'item_image_8.jpg',
				title: '치킨 쿠폰',
				person: '(18명)',
			},
			{
				img: 'item_image_7.jpg',
				title: '커피 기프티콘',
				person: '(50명)',
			},
		],
		prdList1: [
			{
				img: 'item_image_8.jpg',
				title: '치킨 쿠폰',
				sub: '(12월 10일)',
				person: '(10명)',
			},
			{
				img: 'item_image_8.jpg',
				title: '치킨 쿠폰',
				sub: '(12월 20일)',
				person: '(20명)',
			},
		],
		deliveryList: ['5만원 이하 경품 : 카카오 간편가입 시 등록한 번호로 모바일 쿠폰 전송', '5만원 초과 경품 : 개별 연락 후 제세공과금(22%) 납부 안내 및 네이버폼 링크 안내 (배송지 정보) > 제세공과금 납부 확인 후 경품 택배 발송'],

		prectList: ['카카오 간편가입을 하셔야 참여할 수 있습니다.', '카카오 간편가입은 2024년 12월 동행축제 출석체크, 랭킹게임 참여를 위한 간편가입으로 동행축제 홈페이지 가입과는 별개입니다.', '카카오 간편가입 및 네이버폼으로 취합된 개인정보는 이벤트 경품 발송 절차가 모두 완료된 이후에 즉시 폐기 됩니다.', '프로모션 기간 내 무제한 게임 참여가 가능합니다.', '게임 완료 후 결과 창에서 확인 버튼을 클릭해야 점수 반영이 완료되며, 게임 중 간에 페이지를 나가거나 종료된 경우 게임 기록이 저장되지 않습니다.', '게임 기록이 저장되지 않으면 이벤트 참여도 불가합니다.', '동일 점수의 경우 먼저 달성한 분의 상위 등수로 등록됩니다.', '부정 또는 비정상적인 방법으로 참여한 경우 당첨의 취소나 참여가 제한될 수 있습니다.', '지급된 쿠폰 사용 시, 쿠폰 내 유의사항을 반드시 확인 바랍니다.', '당첨 쿠폰이 분실, 도난당한 경우, 재발급이 불가합니다. (당첨 쿠폰 복사 및 저장 필수)', '5만원 초과 경품 당첨의 경우 제세공과금(22%)은 본인이 부담해야 합니다.', '당첨자는 이벤트 종료 후 1개월 이내 공지될 예정입니다.', '당첨자의 잘못된 정보 입력으로 인해 경품 누락이 될 경우 재발송되지 않습니다.', '해당 이벤트에 만 14세 미만은 참여할 수 없습니다.', '이벤트 일정 및 경품 내용은 추후 주최 측의 사정에 따라 변동할 수 있습니다.', '경품 발송 전 회원 탈퇴를 하실 경우, 이벤트 대상에서 제외됩니다.', '게임 이벤트에 관한 문의는 게임 운영 대행사인 지엠컴 070-4838-6391로 문의 바라며, 상담 가능 시간은 평일 오전 9시 ~ 오후 6시입니다.'],
		eventStart: false,
	}),
	computed: {
		isShowBtn() {
			return new Date() < new Date("2024-12-29 00:00:00")
		}
	},
	watch: {},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				const thisTab = document.querySelector('.tab-button.is-active');
				thisTab.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 100);
		});
	},
	methods: {
		clickEvent(e) {
			// let url = 'https://doit5.com/kshoppingfesta/direct?gc=a15';
			let url = 'https://doit5.com/kshoppingfesta/list.php';
			const w = 560;
			const h = 600;
			const title = '이벤트';

			// 브라우저 창의 크기 가져오기
			const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
			const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

			const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
			const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

			// 팝업창의 중앙 좌표 계산
			const left = width / 2 - w / 2 + dualScreenLeft;
			const top = height / 2 - h / 2 + dualScreenTop;

			// 팝업창 설정
			const options = `
				scrollbars=yes,
				width=${w}, 
				height=${h}, 
				top=${top}, 
				left=${left},
				status=no,
				menubar=no,
				toolbar=no,
				location=no,
				directories=no,
				copyhistory=no
			`.replace(/\s+/g, '');

			// 팝업창 열기
			const newWindow = window.open(url, title, options);

			// 팝업창이 차단되었는지 확인
			if (window.focus && newWindow) {
				newWindow.focus();
			}

			return newWindow;
		},
	},
};
</script>
